import React from 'react';
import './PaymentDetails.css';

const formatTime = (dateTime) => {
    const date = new Date(dateTime);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const PaymentDetails = ({ training, formData }) => {
    return (
        <>
            <p><strong>Training:</strong> {training.summary}</p>
            <p><strong>Date:</strong> {new Date(training.start.dateTime).toDateString()}</p>
            <p><strong>Time:</strong> {`${formatTime(training.start.dateTime)} - ${formatTime(training.end.dateTime)}`}</p>
            <p><strong>Name:</strong> {formData.name}</p>
            <p><strong>Last Name:</strong> {formData.lastname}</p>
            <p><strong>Email:</strong> {formData.email}</p>
            <p><strong>Phone Number:</strong> {formData.phone}</p>
            <p><strong>Payment Method:</strong> {formData.paymentMethod}</p>
            <p><strong>Cost:</strong> {training.amount} zł</p>
        </>
    );
};

export default PaymentDetails;
